import AddNoteModal from "./add-note-modal.vue";

export default AddNoteModal;



// WEBPACK FOOTER //
// ./src/components/_modals/add-note/index.js